import type { ScheduleTimeData, WeekdayData } from "@qendo/schedule";
import { compareAsc } from "date-fns";
import { filterUnique } from "~/util/array";
import { formatTimeForHumans, parseTime } from "~/util/dates";
import { plural } from "~/util/string";

export function formatWeekdayString(days?: Partial<WeekdayData> | null): string {
    return [
        days?.monday ? "M" : "",
        days?.tuesday ? "Tu" : "",
        days?.wednesday ? "W" : "",
        days?.thursday ? "Th" : "",
        days?.friday ? "F" : "",
        days?.saturday ? "Sa" : "",
        days?.sunday ? "Su" : "",
    ]
        .filter((v) => v.length > 0)
        .join(", ");
}

export function formatTimes(times?: ScheduleTimeData[] | null): string {
    return (times ?? [])
        .map(({ time }) => parseTime(time))
        .sort(compareAsc)
        .map((time) => formatTimeForHumans(time))
        .filter(filterUnique)
        .join(", ");
}

export function formatInterval(days: number): string {
    if (days >= 7) {
        const weeks = Math.floor(days / 7);
        const remainder = days % 7;
        const day_part = remainder > 0 ? ` and ${remainder} ${plural("day", remainder)}` : "";
        const week_part = weeks === 1 ? "week" : `${weeks} weeks`;

        return `Every ${week_part}${day_part}`;
    }

    switch (days) {
        case 1:
            return "Every day";
        case 2:
            return "Every other day";
        default:
            return `Every ${days} days`;
    }
}
